const nl = {
    'create_account': 'Maak een <br> account aan',
    'to_register_you_will_need': 'Om te registeren heeft u nodig:',
    'reg_term_1': 'Een geldig rijbewijs (categorie B)',
    'reg_term_2': 'Een mobiel telefoonnummer',
    'reg_term_3': 'Een emailadres',
    'register': 'Registreer',
    'sign_1': 'Ik verklaar dat mijn rijbewijs echt is',
    'sign_2': 'Ik ga ermee akkoord dat mijn foto’s en persoonlijke gegevens zichtbaar worden opgeslagen voor onze medewerkers.',
    'cancel': 'Annuleer',
    'confirm': 'Bevestig',
    'document_verification': 'Documentverificatie',
    'dv_1': 'Maak een foto van het rijbewijs',
    'dv_2': 'Check of alle gegevens kloppen',
    'dv_3': 'Maak een selfie    ',
    'continue': 'Ga verder',
    'take_a_photo_of_the_front': 'Maak een foto van de voorkant',
    'attention': 'Let op!',
    'at_1': 'We accepteren alleen foto’s van het originele rijbewijs',
    'at_2': "Maak geen foto's van kopieën van documenten of afbeeldingen van andere apparaten",
    'take_a_photo': 'Maak een foto',
    'camera_text_1': 'Houd de camera parallel aan het oppervlak',
    'camera_text_2': 'Druk op de knop om een foto te maken...',
    'take_a_photo_of_the_back': 'Maak een foto van de achterkant',
    'drivers_license': 'Rijbewijs',
    'selfie': 'Selfie',
    'name': 'Naam',
    'surname': 'Achternaam',
    'country_of_issue': 'Land van uitgifte van het rijbewijs',
    'drivers_license_number': 'Rijbewijsnummer',
    'expiration_date': 'Verloopdatum',
    'date_of_birth': 'Geboortedatum',
    'category_b': 'Categorie B',
    'dl_problem': 'Er is iets mis met je rijbewijs',
    'please_call_us': 'Bel ons alstublieft <a href="tel:0880883434">088 - 088 34 34</a>',
    'close': 'Sluiten',
    'is_info_correct': 'Is de ingevulde informatie correct?',
    'yes': 'Ja',
    'no': 'Nee',
    'ok': 'Ja',
    'not_dutch_dl': 'Omdat u geen Nederlands rijbewijs heeft is het verplicht om ook een foto van een andere ID in te sturen',
    'choose_the_type_of_your_document': 'Kies uw identificatiebewijs',
    'passport': 'Paspoort',
    'id_card': 'ID kaart ',
    'passport_id_card_number': 'Paspoort / ID kaart nummer',
    'zip_code': 'Postcode',
    'house_number': 'Huisnummer',
    'number_addition': 'Toevoeging',
    'street': 'Straat',
    'city': 'Gemeente',
    'country': 'Land',
    'use_the_same': 'Gebruik hetzelfde adres voor de factuur',
    'email': 'Email',
    'phone': 'Telefoon',
    'credentials': 'Inloggegevens',
    'set_24_password': 'Stuur mij een 24 uurs wachtwoord per sms',
    'sign_your_new_contract': 'Teken je nieuwe contract',
    'agree_1': 'Ik verklaar hierbij dat ik de Algemene Voorwaarden heb gelezen en ermee akkoord ga',
    'agree_2': 'Hierbij verklaar ik dat ik de huisregels heb gelezen en hiermee akkoord ga',
    'agree_3': 'Ik verklaar hierbij dat ik het klantcontract heb gelezen en ermee akkoord ga',
    'agree_4': 'Ik verklaar hierbij dat ik de procedure uitleg heb gelezen en ermee akkoord ga',
    'agree': 'Mee eens',
    'welcome': 'Welkom!',
    'rent_a_bus': 'Huur een bus',
    'get_the_app': 'Download de App!',
    'already_account_title': 'Je hebt al een account!',
    'already_account_text': 'Download de applicatie om door te gaan',
    'download': 'Downloaden',
    'contacts': 'Contactgegevens',
    'the_are_problems_with_your_camera': '',
    'permission_to_camera': 'Er is geen camera aanwezig. Gebruik uw mobiele telefoon om de registratie af te ronden.',
    'home_zip_code': 'Postcode thuis',
    'home_house_number': 'Home Huisnummer',
    'home_street': 'Thuisstraat',
    'home_city': 'Thuis stad',
    'invoice_zip_code': 'Factuur postcode',
    'invoice_house_number': 'Factuur Huisnummer',
    'invoice_street': 'Factuurstraat',
    'invoice_city': 'Factuur Stad',
    'you_did_not_provide': 'Je hebt niet verstrekt:',
    'home_address': 'Huisadres',
    'invoice_address': 'Factuuradres',
    'error': 'Fout',
    'password': 'Wachtwoord',
    'pas_req_1': 'Minimaal 7 karakters',
    'pas_req_2': 'Minimaal 1 cijfer en 1 letter',
    'repeat_password': 'Herhaal wachtwoord',
    'pas_error': 'Wachtwoorden moeten overeenkomen en complex zijn',
    'photo_auto': 'De foto wordt automatisch gemaakt, wacht alstublieft...',
    'front_of_id_card': 'Voorkant ID kaart',
    'document_number': 'Document Nummer',
    'selfie_pic_text': "Maak geen foto's van uzelf vanaf andere foto's of andere apparaten.",
    'make_selfie': 'Selfie maken',
    'already_account': 'je hebt al een account!',
    'customer_with_email_1': 'De klant met',
    'customer_with_email': 'emailadres',
    'already_exists': 'bestaat al..',
    'call_us_2': 'Bel ons alstublieft of reset uw wachtwoord',
    'reset_password': 'Herstel wachtwoord',
    'call_us': 'Bel ons',
    'dl_exp_date': 'Verloopdatum rijbewijs',
    'no_need': 'Nee',
    'recovery_link_message': 'Een herstellink is naar uw emailadres gestuurd',
}

export default nl